import awsconfig from '@/aws-exports';
import {getLang} from '@/locale'

export default {
    namespaced:true,
    state: {
        locale: getLang(),
        drawer: null,
        drawerHidden: null,
        notification: false,
        notificationData: { error: false,
            text: 'Operation finished sucessfully',
        },
        wizard: false,
        savedDrawerState: null,
        wizards: {
            company: [
                { title: 'companies.wizard.create', route: 'add-company' },
                { title: 'companies.wizard.business', route: 'business' },
                { title: 'companies.wizard.project', route: 'domains' }
            ],
            domain: [
                { title: 'domains.wizard.basic', route: 'add-domain' },
                { title: 'domains.wizard.feeds', route: 'feeds' },
                { title: 'domains.wizard.tracking', route: 'tracking-dynamic', stepMatchRegex: /tracking/ },
                //{ title: 'webboxes.title', route: 'webboxes', stepMatchRegex: /webboxes/ },
                { title: 'mailing.title', route: 'mailing' },
                { title: 'integrations.title', optional: true, route: 'integrations' },
                { title: 'domains.wizard.review', route: 'domain-overview' }
            ],
            campaign: [
                { title: 'campaigns.wizard.type', route: 'add-campaign' },
                { title: 'campaigns.wizard.contacts', route: 'campaign-segment', editable: true },
                { title: 'campaigns.wizard.setup', route: 'campaign-setup-dynamic', stepMatchRegex: /campaign-setup/, editable: true },
                { title: 'campaigns.wizard.design', route: 'campaign-design-dynamic', stepMatchRegex: /campaign-design/, editable: true },
                { title: 'campaigns.wizard.summary', route: 'campaign-summary-dynamic', stepMatchRegex: /campaign-summary/, editable: true },
                { title: 'campaigns.wizard.start', route: true, editable: true },
            ]
        },
        wizardEntryPoints: {
            company: 'companies',
            domain: 'domains',
            campaign: 'domain-dashboard'
        },
        
        dynamicEntryPoint: null,
        lastEditableStep: null
    },
    mutations: {
        drawer: (state, payload) => { state.drawer = payload.value },
        locale: (state, payload) => { state.locale = payload.value },
        wizard: (state, payload) => { 
            if(payload.value == state.wizard) {
                // do not overwrite saved drawer state etc.
                return;
            }
            state.wizard = payload.value; 
            /* not working in some situations */
            if(state.wizard && !payload.keepDrawer) {
                state.savedDrawerState = state.drawer;
                state.drawer = false;
                state.drawerHidden = true; 
            } else if(state.drawerHidden) {
                // if state was null, drawer was not initialized yet - open it
                state.drawer = state.savedDrawerState == null ? true : state.savedDrawerState;
                state.drawerHidden = null;
                state.lastEditableStep = null;
            }
        },
        lastEditableStep: (state, payload) => { state.lastEditableStep = payload.value },
        dynamicEntryPoint: (state, payload) => {state.dynamicEntryPoint = payload.value },
        notification: (state, payload) => { state.notification = payload.value },
        notificationData: (state, payload) => { state.notificationData = payload.value },
    },
    getters: {
        baseUrl: () => process.env.VUE_APP_PUBLIC_URL || awsconfig["aws_content_delivery_url"],
        mediaUrl: () => `${awsconfig['aws_user_files_s3_bucket']}.s3.${awsconfig['aws_user_files_s3_bucket_region']}.amazonaws.com`, //http://dreamroirecommenderproductmedia125240-dev.s3.eu-central-1.amazonaws.com/products/932f9ce9-2efb-4966-85ef-0708333ca030/9b16293a-cf85-4327-8f55-b448fb921419.jpg
        pixelUrl: () => `${awsconfig['aws_cloud_logic_custom'].find(api => api.name == 'dreamroipixel').endpoint}/pixel/message/{{ MESSAGE_ID }}/pixel.png`,
        trackerUrl: () => `${awsconfig['aws_cloud_logic_custom'].find(api => api.name == 'dreamroitrackerapi').endpoint}`,
        shopifyUrl: () => process.env.VUE_APP_SHOPIFY_STORE_URL,
        shopifyBoxesVideoOS2: () => `https://www.youtube.com/embed/${process.env.VUE_APP_SHOPIFY_BOXES_VIDEO_OS2}`,
        step: (state) => (r) => {
            var cs = state.wizards.company.findIndex(s => s.route == r || (s.stepMatchRegex && s.stepMatchRegex.test(r)));
            if (cs!=-1) {
                return cs;
            } 
            var ds = state.wizards.domain.findIndex(s => s.route == r  || (s.stepMatchRegex && s.stepMatchRegex.test(r)));
            if(ds != -1) {
                return ds;
            }
            return state.wizards.campaign.findIndex(s => s.route == r  || (s.stepMatchRegex && s.stepMatchRegex.test(r)));
        },
        wizardType: (state) => (r) => {
            return Object.keys(state.wizards).find(wt => state.wizards[wt].some(s => s.route == r || (s.stepMatchRegex && s.stepMatchRegex.test(r))));
        },
        wizardEntryPoint: (state, getters) => (r) => {
            return { name: state.dynamicEntryPoint || state.wizardEntryPoints[getters.wizardType(r)] };
        },
        nextStep: (state, getters) => (r) => {
            var s = getters.step(r);
            var wt = getters.wizardType(r);
            if(s == state.wizards[wt].length - 1) {
                // this is the last step of the wizard
                // return getters.wizardEntryPoint(r);
                return null;
            }
            return state.wizards[wt][s+1].route;
        }
    },
    actions: {
        notify(context, payload) {
            context.commit('notificationData', { value: payload });
            context.commit('notification', { value: true });
        }
    }
}